import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from "react-router-dom";
import API_ENDPOINTS from "../../utils/apiEndpoints";

const FileUpload = () => {
    const navigate = useNavigate();
    const fileInputPhotoRef = useRef(null);
    const fileInputDocumentsRef = useRef(null);

    const [loading, setLoading] = useState(false);

    const { id } = useParams();

    const [formData, setFormData] = useState({
        healthProblem: '',
        health_file: null,
        student_photo: null,
        student_adhaar: null,
        student_signature: null,
        father_signature: null,
        mother_signature: null,
        mother_adhaar: null,
        father_adhaar: null,
    });


    const [uploadStatus, setUploadStatus] = useState({
        health_file: "N/A",
        student_photo: "N/A",
        student_adhaar: "N/A",
        student_signature: "N/A",
        father_signature: "N/A",
        mother_signature: "N/A",
        mother_adhaar: "N/A",
        father_adhaar: "N/A",
    });

    const [uploadedFileNames, setUploadedFileNames] = useState({
        health_file: "",
        student_photo: "",
        student_adhaar: "",
        student_signature: "",
        father_signature: "",
        mother_signature: "",
        mother_adhaar: "",
        father_adhaar: "",
    });
    // console.log(formData);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFileChange = (event, field) => {
        const file = event.target.files[0];

        if (file && file.name.includes(' ')) {
            alert("File names cannot contain spaces. Please rename your file (e.g., use an underscore '_' instead of a space) and try again.");
            event.target.value = ""; // Reset the input
            return;
        }

        setFormData((prev) => ({
            ...prev,
            [field]: file || null,
        }));

        // Reset upload status and file name when selecting a new file
        setUploadStatus((prev) => ({
            ...prev,
            [field]: "",
        }));

        setUploadedFileNames((prev) => ({
            ...prev,
            [field]: "",
        }));
    };

    const handleUpload = async (field) => {
        if (!formData[field] || !(formData[field] instanceof File)) {
            console.error("Invalid file:", formData[field]);
            alert("Invalid file selected.");
            return;
        }

        setUploadStatus((prev) => ({ ...prev, [field]: "Uploading..." }));

        const data = new FormData();
        data.append("attachment", formData[field]);
        data.append("type", field);
        data.append("student_id", id);

        try {
            const token = localStorage.getItem("parentToken"); // Include token if required

            const response = await axios.post(API_ENDPOINTS.FILE_UPLOAD,
                data,
                { headers: { "Content-Type": "multipart/form-data", ...(token ? { Authorization: `Bearer ${token}` } : {}) } }
            );

            // console.log(response);
            setUploadStatus((prev) => ({ ...prev, [field]: "Uploaded" }));
            setUploadedFileNames((prev) => ({
                ...prev,
                [field]: formData[field].name,
            }));
        } catch (error) {
            console.error("Upload failed", error);

            // Extract error message dynamically
            let errorMessage = "Upload failed. Please try again.";
            if (error.response && error.response.data) {
                if (error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                if (error.response.data.data) {
                    const errors = Object.values(error.response.data.data).flat();
                    if (errors.length > 0) {
                        errorMessage = errors.join("\n");
                    }
                }
            }

            alert(errorMessage); // Show error dynamically in alert
            setUploadStatus((prev) => ({ ...prev, [field]: "Upload Failed" }));
        }
    };



    // console.log(uploadStatus);
    const handleFinalSubmit = async (e) => {
        e.preventDefault();

        // List of required fields
        const requiredFields = [
            "student_photo",
            "student_adhaar",
            "student_signature",
            "father_signature",
            "mother_signature",
            "mother_adhaar",
            "father_adhaar",
        ];

        if (formData.healthProblem === "yes") {
            requiredFields.push("health_file");
        }

        // Check if all required fields are strictly "Uploaded"
        const allFieldsValid = requiredFields.every(
            (field) => uploadStatus[field] === "Uploaded"
        );

        if (!allFieldsValid) {
            alert("Please upload all required files before submitting the form.");
            return; // Stop form submission if validation fails
        }

        // If all required fields are valid, proceed with form submission
        navigate(`/admission-rules/${id}`);
        setFormData({
            healthProblem: '',
            health_file: null,
            student_photo: null,
            student_adhaar: null,
            student_signature: null,
            father_signature: null,
            mother_signature: null,
            mother_adhaar: null,
            father_adhaar: null,
        });

        // Uncomment the following code if you want to make an API call
        /*
        try {
            const mobile = 1234567899;
            const response = await axios.post("http://127.0.0.1:8000/api/send-otp", { mobile });
            console.log(response.data.otp);
            console.log(response);
            navigate("/admission-rules");
            setFormData({
                healthProblem: '',
                health_file: null,
                student_photo: null,
                student_adhaar: null,
                student_signature: null,
                father_signature: null,
                mother_signature: null,
                mother_adhaar: null,
                father_adhaar: null,
            });
        } catch (error) {
            console.error("Error submitting form:", error);
        }
        */
    };

    return (
        <div className="w-full min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="w-full max-w-2xl bg-white rounded-lg shadow-md p-6">
                <h2 className="text-xl font-semibold text-center mb-4">File Uploads Form</h2>
                <form onSubmit={handleFinalSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {/* Health Problem */}
                    <div className="sm:col-span-2">
                        <label className="block text-sm font-medium text-gray-600">
                            Does he/she have any health problem?
                        </label>
                        <input
                            type="radio"
                            name="healthProblem"
                            value="yes"
                            required
                            checked={formData.healthProblem === "yes"}
                            onChange={(e) => handleChange(e)}
                            disabled={uploadStatus.health_file === "Uploaded"}
                        /> Yes
                        &nbsp;
                        <input
                            type="radio"
                            name="healthProblem"
                            value="no"
                            checked={formData.healthProblem === "no"}
                            onChange={(e) => handleChange(e)}
                            disabled={uploadStatus.health_file === "Uploaded"}
                        /> No
                        {formData.healthProblem === "yes" && (
                            <div className="mx-auto mt-2">
                                <label className="mb-1 block text-sm font-medium text-gray-700">
                                    Upload file
                                </label>
                                <input
                                    type="file"
                                    name="health_file"
                                    ref={fileInputDocumentsRef}
                                    onChange={(e) => handleFileChange(e, "health_file")}
                                    className="mt-2 block w-full text-sm file:mr-4 file:rounded-md file:border-0 file:bg-blue-500 file:py-2 file:px-4 file:text-sm file:font-semibold file:text-white hover:file:bg-blue-700 focus:outline-none disabled:pointer-events-none disabled:opacity-60 cursor-pointer"
                                />
                                {formData.health_file && uploadStatus.health_file !== "Uploaded" && uploadStatus.health_file !== "Uploading..." && (
                                    <p className="text-red-500 text-xs mt-1 font-medium italic">⚠️ Please click the button below to upload this file</p>
                                )}
                                {formData.health_file && (
                                    <button
                                        type="button"
                                        onClick={() => handleUpload("health_file")}
                                        disabled={uploadStatus.health_file === "Uploading..."}
                                        className={`mt-2 w-full text-white font-semibold py-2 px-4 rounded-lg transition duration-200 ${uploadStatus.health_file === "Uploaded"
                                            ? "bg-green-500 hover:bg-green-700"
                                            : uploadStatus.health_file === "Uploading..."
                                                ? "bg-gray-500 hover:bg-gray-700"
                                                : "bg-blue-500 hover:bg-blue-700"
                                            }`}
                                    >
                                        {uploadStatus.health_file === "Uploaded"
                                            ? "Uploaded"
                                            : uploadStatus.health_file === "Uploading..."
                                                ? "Uploading..."
                                                : "Upload Health File"}
                                    </button>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Upload Fields */}
                    {[
                        { name: "student_photo", label: "Upload Student Photo", accept: "image/*", required: true },
                        { name: "student_adhaar", label: "Upload Student Aadhaar", accept: ".pdf,.doc,.docx", required: true },
                        { name: "student_signature", label: "Upload Student Signature", accept: ".pdf,.doc,.docx", required: true },
                        { name: "father_signature", label: "Upload Father's Signature", accept: ".pdf,.doc,.docx", required: true },
                        { name: "mother_signature", label: "Upload Mother's Signature", accept: ".pdf,.doc,.docx", required: true },
                        { name: "mother_adhaar", label: "Upload Mother's Aadhaar", accept: ".pdf,.doc,.docx", required: true },
                        { name: "father_adhaar", label: "Upload Father's Aadhaar", accept: ".pdf,.doc,.docx", required: true }
                    ].map(({ name, label, accept, required }) => (
                        <div key={name}>
                            <label className="block text-sm font-medium text-gray-600">{label}</label>
                            <input
                                required={required}
                                type="file"
                                name={name}
                                ref={fileInputDocumentsRef}
                                onChange={(e) => handleFileChange(e, name)}
                                accept={accept}
                                className="mt-2 block w-full text-sm file:mr-4 file:rounded-md file:border-0 file:bg-blue-500 file:py-2 file:px-4 file:text-sm file:font-semibold file:text-white hover:file:bg-blue-700 focus:outline-none disabled:pointer-events-none disabled:opacity-60 cursor-pointer"
                            />
                            {formData[name] && uploadStatus[name] !== "Uploaded" && uploadStatus[name] !== "Uploading..." && (
                                <p className="text-red-500 text-xs mt-1 font-medium italic">⚠️ Please click the button below to upload this file</p>
                            )}
                            {formData[name] && (
                                <button
                                    type="button"
                                    onClick={() => handleUpload(name)}
                                    disabled={uploadStatus[name] === "Uploading..."}
                                    className={`mt-2 w-full text-white font-semibold py-2 px-4 rounded-lg transition duration-200 ${uploadStatus[name] === "Uploaded"
                                        ? "bg-green-500 hover:bg-green-700"
                                        : uploadStatus[name] === "Uploading..."
                                            ? "bg-gray-500 hover:bg-gray-700"
                                            : "bg-blue-500 hover:bg-blue-700"
                                        }`}
                                >
                                    {uploadStatus[name] === "Uploaded"
                                        ? "Uploaded"
                                        : uploadStatus[name] === "Uploading..."
                                            ? "Uploading..."
                                            : ` ${label}`}
                                </button>
                            )}
                        </div>
                    ))}

                    {/* Submit Button (Full Width) */}
                    <div className="sm:col-span-2 mt-3">
                        <button
                            type="submit"
                            className="w-full bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
                        >
                            Next
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FileUpload;